var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingForQuotation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 14V17.1409H21.8121H42.5906H44.4027V14H20Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8121 46.8591H20V50.0001H44.4027V46.8591H42.5906H21.8121Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5901 24.3893V18.7517H21.8115V24.3893C21.8115 24.8322 22.0129 25.2752 22.335 25.5571L29.7847 32L22.3753 38.443C22.0531 38.7249 21.8518 39.1678 21.8518 39.6108V45.2484H42.5901V39.6108C42.5901 39.1678 42.3887 38.7249 42.0666 38.443L34.5766 32L42.0263 25.5571C42.3484 25.2752 42.5498 24.8322 42.5901 24.3893Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingForQuotation);
export default __webpack_public_path__ + "static/media/pendingForQuotation.3b5cc275a868ce208857393d92c3bf4a.svg";
export { ForwardRef as ReactComponent };